export default __webpack_public_path__ + "static/media/fireFN29.ff119722.svg";